(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["raceclub-price-match-prompt"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('raceclub-price-match')) {
    const readMatchPreviewContext = () => {
      const params = new URLSearchParams(window.location.search);
      const values = params.getAll('preview_theme_id');
      return {
        present: values.length > 0,
        id: values.length === 1 && /^[1-9]\d{0,19}$/.test(values[0]) ? values[0] : null
      };
    };
    customElements.define('raceclub-price-match', class extends HTMLElement {
      static shown = false;
      static previewThemeId = readMatchPreviewContext().id;
      connectedCallback() {
        if (this.matchConnected) return;
        this.matchConnected = true;
        this.onMatchCopy = this.handleMatchCopy.bind(this);
        this.onMatchClick = this.handleMatchClick.bind(this);
        this.onMatchKey = (event) => {
          if (event.key === 'Escape' && this.querySelector('[data-rc-match-prompt]')?.contains(event.target)) this.dismissMatchPrompt();
        };
        document.addEventListener('copy', this.onMatchCopy);
        this.addEventListener('click', this.onMatchClick, true);
        this.addEventListener('keydown', this.onMatchKey);
        this.syncMatchLinks();
      }
      disconnectedCallback() {
        document.removeEventListener('copy', this.onMatchCopy);
        this.removeEventListener('click', this.onMatchClick, true);
        this.removeEventListener('keydown', this.onMatchKey);
        this.matchConnected = false;
      }
      matchUrl(hash = 'ContactForm') {
        try {
          const origin = window.location.origin;
          const contact = new URL(this.dataset.contactPath, origin);
          const product = new URL(this.dataset.productUrl, origin);
          if (contact.origin !== origin || product.origin !== origin || contact.username || contact.password || product.username || product.password) return null;
          if (!/\/(?:pages\/contact)\/?$/.test(contact.pathname) || !/\/products\/[^/]+\/?$/.test(product.pathname)) return null;
          if (!/^\d+$/.test(this.dataset.variantId || '')) return null;
          product.search = '';
          product.hash = '';
          product.searchParams.set('variant', this.dataset.variantId);
          contact.search = '';
          const context = {
            request: 'price-match', product: this.dataset.productTitle,
            product_url: product.pathname + product.search,
            variant_id: this.dataset.variantId, variant: this.dataset.variantTitle,
            sku: this.querySelector('[data-rc-match-sku]')?.textContent.trim() || ''
          };
          Object.entries(context).forEach(([key, value]) => {
            if (value) contact.searchParams.set(key, value.slice(0, 500));
          });
          const preview = readMatchPreviewContext();
          if (preview.present) this.constructor.previewThemeId = preview.id;
          if (this.constructor.previewThemeId) contact.searchParams.set('preview_theme_id', this.constructor.previewThemeId);
          contact.hash = hash;
          return contact.href;
        } catch { return null; }
      }
      syncMatchLinks() {
        const requestUrl = this.matchUrl();
        const termsUrl = this.matchUrl('RcPriceMatchTerms');
        if (requestUrl) this.querySelectorAll('[data-rc-match-request]').forEach((link) => { link.href = requestUrl; });
        if (termsUrl) this.querySelectorAll('[data-rc-match-terms]').forEach((link) => { link.href = termsUrl; });
      }
      handleMatchCopy(event) {
        if (!event.isTrusted || this.constructor.shown || this.closest('[hidden], .hidden, .visibility-hidden, quick-add-modal')) return;
        try { if (sessionStorage.getItem('rc-price-match-nudge:v1') === '1') return; } catch {}
        const editable = 'input, textarea, [contenteditable]';
        if (event.target?.closest?.(editable) || document.activeElement?.closest?.(editable)) return;
        const source = this.querySelector('[data-rc-match-sku]');
        const selection = document.getSelection();
        if (!source || !source.textContent.trim() || !selection || selection.isCollapsed || selection.rangeCount !== 1 || !this.matchUrl()) return;
        const range = selection.getRangeAt(0);
        if (!source.contains(range.startContainer) || !source.contains(range.endContainer) || selection.toString().trim() !== source.textContent.trim()) return;
        this.constructor.shown = true;
        try { sessionStorage.setItem('rc-price-match-nudge:v1', '1'); } catch {}
        window.setTimeout(() => {
          if (!this.isConnected || event.defaultPrevented) return;
          const notice = this.querySelector('[data-rc-match-prompt]');
          const announcement = this.querySelector('[data-rc-match-announcement]');
          if (!notice || !announcement) return;
          notice.hidden = false;
          announcement.textContent = this.dataset.announcement;
        }, 0);
      }
      dismissMatchPrompt() {
        const notice = this.querySelector('[data-rc-match-prompt]');
        if (!notice) return;
        if (notice.contains(document.activeElement)) this.querySelector('[data-rc-match-fallback]')?.focus();
        notice.hidden = true;
        const announcement = this.querySelector('[data-rc-match-announcement]');
        if (announcement) announcement.textContent = '';
      }
      handleMatchClick(event) {
        if (event.target.closest('[data-rc-match-dismiss]')) this.dismissMatchPrompt();
        this.syncMatchLinks();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["raceclub-price-match-request-fields"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('raceclub-price-match-fields')) {
    customElements.define('raceclub-price-match-fields', class extends HTMLElement {
      connectedCallback() {
        if (this.matchFieldsConnected) return;
        this.matchFieldsConnected = true;
        const params = new URLSearchParams(window.location.search);
        if (params.get('request') !== 'price-match') return;
        this.querySelector('[data-rc-match-details]').open = true;
        this.querySelector('[data-rc-match-requested]').checked = true;
        const values = {
          product: (params.get('product') || '').slice(0, 500),
          sku: (params.get('sku') || '').slice(0, 256),
          variant: (params.get('variant') || '').slice(0, 500)
        };
        const variantId = params.get('variant_id') || '';
        if (/^\d{1,30}$/.test(variantId)) values.variant_id = variantId;
        try {
          const path = params.get('product_url');
          if (path && path.length <= 1000) {
            const product = new URL(path, window.location.origin);
            if (product.origin === window.location.origin && !product.username && !product.password && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/.test(product.pathname)) {
              product.search = '';
              product.hash = '';
              if (values.variant_id) product.searchParams.set('variant', values.variant_id);
              values.product_url = product.href;
            }
          }
        } catch {}
        Object.entries(values).forEach(([key, value]) => {
          const field = this.querySelector('[data-rc-match-field="' + key + '"]');
          if (field && !field.value.trim()) field.value = value;
        });
        if (window.location.hash === '#RcPriceMatchTerms') this.querySelector('#RcPriceMatchTerms').open = true;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
